export default {
    getProjectNumber:'/index.php/cqh/Statistics/getProjectNumber',//项目总体情况
    getOffProjectNumber:'/index.php/cqh/Statistics/getOffProjectNumber',//计划外项目情况
    GetOpenSign:'/index.php/cqh/open/GetOpenSign',//获取跳转数字孪生接口参数
}